import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import {
  FaBars,
  FaTruckMoving,
  FaShieldAlt,
  FaHeadset,
  FaCheckCircle,
  FaBuilding,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaPaperPlane,
  FaWhatsapp,
  FaLinkedin,
  FaTwitter,
  FaUser,
  FaArrowRight,
  FaClock,
  FaStar,
  FaGlobe,
  FaWarehouse,
  FaUsers,
  FaAward,
  FaQuoteLeft,
  FaTimes,
  FaIndustry,
  FaChartBar,
  FaLock,
  FaMapPin,
} from "react-icons/fa";
import logo from "../Images/paras&roadlines.jpg";
import logo1 from "../Images/para.png";
import { Link } from "react-router-dom";
import {
  getCustomers,
  getTestimonials,
  submitContactEnquiry,
} from "../Services/Services";

gsap.registerPlugin(ScrollTrigger);

function LandingPage01() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formFeedback, setFormFeedback] = useState(null);
  const [activeSection, setActiveSection] = useState("home");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  // const heroTextRef = useRef(null);
  const parallaxBgRef = useRef(null);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const customersRef = useRef(null);
  const contactRef = useRef(null);
  const navigate = useNavigate();

  const scrollToSection = (ref, id) => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    setActiveSection(id);
    setMobileMenuOpen(false);
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  const slideInterval = useRef(null);

  const heroSlides = [
    {
      image:
        "https://res.cloudinary.com/dwhjq29li/image/upload/v1778325118/bg-trans_wywuum.png",
      eyebrow: "India's Premier Road LR Partner Since 1986",
      title1: "PARAS",
      title2: "ROADLINES",
      desc: "End-to-end road freight solutions with GPS-enabled fleet, real-time tracking.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1920&q=80",
      eyebrow: "Full Truck Load Services Across India",
      title1: "FULL TRUCK",
      title2: "LOAD",
      desc: "Dedicated fleet for exclusive cargo with guaranteed delivery timelines across 100+ cities.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1920&q=80",
      eyebrow: "Secure & Modern Warehousing",
      title1: "WAREHOUSE",
      title2: "SOLUTIONS",
      desc: "Tech-enabled storage with inventory management and seamless dispatch integration.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1920&q=80",
      eyebrow: "Comprehensive Cargo Protection",
      title1: "CARGO",
      title2: "INSURANCE",
      desc: "Full financial protection for every shipment against damage, theft, and transit risks.",
    },
    {
      image:
        "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1920&q=80",
      eyebrow: "Heavy Machinery & ODC Transport",
      title1: "PROJECT",
      title2: "LOGISTICS",
      desc: "Specialized handling for oversized cargo and complex project-based movements.",
    },
  ];

  useEffect(() => {
    const spy = () => {
      const y = window.scrollY + 100;
      const secs = [
        { id: "home", ref: homeRef },
        { id: "about", ref: aboutRef },
        { id: "services", ref: servicesRef },
        { id: "contact", ref: contactRef },
      ];
      for (let i = secs.length - 1; i >= 0; i--) {
        const el = secs[i].ref.current;
        if (
          el &&
          y >= el.offsetTop - 50 &&
          y < el.offsetTop + el.offsetHeight - 50
        ) {
          setActiveSection(secs[i].id);
          break;
        }
      }
    };
    window.addEventListener("scroll", spy);
    spy();
    return () => window.removeEventListener("scroll", spy);
  }, []);

  useEffect(() => {
    const fn = () => {
      setScrolled(window.scrollY > 50);
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const cards = document.querySelectorAll(
      ".service-card,.stat-card,.why-card,.about-badge-card",
    );
    cards.forEach((card) =>
      gsap.fromTo(
        card,
        { autoAlpha: 0, y: 40 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        },
      ),
    );
    document.querySelectorAll(".about-feature").forEach((el, i) =>
      gsap.fromTo(
        el,
        { autoAlpha: 0, x: -30 },
        {
          autoAlpha: 1,
          x: 0,
          duration: 0.5,
          delay: i * 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 92%",
            toggleActions: "play none none none",
          },
        },
      ),
    );
    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  useEffect(() => {
    slideInterval.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 4000);
    return () => clearInterval(slideInterval.current);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);
      try {
        const [customersData, testimonialsData] = await Promise.all([
          getCustomers(),
          getTestimonials(),
        ]);

        // Filter only active records and sort by display_order
        const activeCustomers = Array.isArray(customersData)
          ? customersData
              .filter((c) => c.is_active)
              .sort((a, b) => a.display_order - b.display_order)
          : [];

        const activeTestimonials = Array.isArray(testimonialsData)
          ? testimonialsData
              .filter((t) => t.is_active)
              .sort((a, b) => a.display_order - b.display_order)
          : [];

        setCustomers(activeCustomers);
        setTestimonials(activeTestimonials);
      } catch (error) {
        console.error("Failed to fetch landing page data:", error);
        setCustomers([]);
        setTestimonials([]);
      } finally {
        setDataLoading(false);
      }
    };

    fetchData();
  }, []);

  const validateEmail = (val) => {
    if (!val) return "Email is required.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val))
      return "Invalid email address.";
    return "";
  };

  const validatePhone = (val) => {
    if (!val) return ""; // optional field
    const cleaned = val.replace(/\s|-/g, "");
    if (!/^[6-9]\d{9}$/.test(cleaned))
      return "Enter valid 10-digit number (starts with 6–9).";
    return "";
  };

 const handleContactSubmit = async (e) => {
  e.preventDefault();

  const name = e.target.name.value.trim();
  const email = e.target.email.value.trim();
  const phone = e.target.phone?.value?.trim() || "";
  const company = e.target.company?.value?.trim() || "";
  const message = e.target.message.value.trim();

  // ── Validations ──
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[6-9]\d{9}$/;

  if (!name) {
    setFormFeedback({ type: "error", message: "Full name is required." });
    return;
  }

  if (!email) {
    setFormFeedback({ type: "error", message: "Email address is required." });
    return;
  }

  if (!emailRegex.test(email)) {
    setFormFeedback({ type: "error", message: "Please enter a valid email address." });
    return;
  }

  if (phone && !phoneRegex.test(phone.replace(/\s|-/g, ""))) {
    setFormFeedback({
      type: "error",
      message: "Enter a valid 10-digit Indian mobile number (starts with 6–9).",
    });
    return;
  }

  if (!message) {
    setFormFeedback({ type: "error", message: "Message / Requirement is required." });
    return;
  }

  if (message.length < 10) {
    setFormFeedback({ type: "error", message: "Message must be at least 10 characters." });
    return;
  }

  setIsSubmitting(true);

  try {
    const result = await submitContactEnquiry({
      name,
      email,
      phone,
      company,
      message,
    });

    if (result && result.id) {
      e.target.reset();
      setFieldErrors({});
      setFormFeedback(null);
      setShowSuccessPopup(true);
      setTimeout(() => setShowSuccessPopup(false), 5000);
    } else {
      setFormFeedback({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
      setTimeout(() => setFormFeedback(null), 5000);
    }
  } catch {
    setFormFeedback({
      type: "error",
      message: "Network error. Please try again.",
    });
    setTimeout(() => setFormFeedback(null), 5000);
  } finally {
    setIsSubmitting(false);
  }
};

  const handleLoginClick = () => navigate("/login");
  const handleTeamClick = () => {
    setMobileMenuOpen(false);
    navigate("/our-team");
  };

  // Services — ordered as required
  const services = [
    {
      icon: <FaTruckMoving />,
      title: "Full Truck Load",
      desc: "Dedicated fleet for exclusive cargo with real-time GPS tracking and guaranteed delivery timelines.",
    },
    {
      icon: <FaWarehouse />,
      title: "Warehousing Solutions",
      desc: "Secure, tech-enabled storage with inventory management and seamless dispatch integration.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Cargo Insurance",
      desc: "Comprehensive coverage for every shipment, ensuring full financial protection against risk.",
    },
    {
      icon: <FaIndustry />,
      title: "Project Logistics",
      desc: "Specialized handling for heavy machinery, oversized cargo, and complex project-based movements.",
    },
    {
      icon: <FaGlobe />,
      title: "LR Forwarding",
      desc: "End-to-end multimodal freight forwarding with documentation and customs coordination.",
    },
  ];

  const stats = [
    { icon: <FaUsers />, value: "10,000+", label: "Satisfied Clients" },
    { icon: <FaTruckMoving />, value: "250+", label: "Fleet Vehicles" },
    { icon: <FaGlobe />, value: "100+", label: "Cities Covered" },
    { icon: <FaAward />, value: "40+", label: "Years Experience" },
    { icon: <FaStar />, value: "98%", label: "On-Time Delivery" },
    { icon: <FaChartBar />, value: "500K+", label: "Shipments Delivered" },
  ];

  // Renamed section: "Anything, Anywhere"
  const whyUs = [
    {
      icon: <FaShieldAlt />,
      title: "Zero Damage Policy",
      desc: "Industry-best cargo handling standards with insurance coverage on every single shipment.",
      num: "01",
    },
    {
      icon: <FaChartBar />,
      title: "Transparent Pricing",
      desc: "No hidden charges. Competitive quotes with detailed cost breakdowns delivered instantly.",
      num: "02",
    },
    {
      icon: <FaClock />,
      title: "98.2% On-Time Rate",
      desc: "Consistently meeting delivery commitments through optimized routing and proactive monitoring.",
      num: "03",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Dedicated Support",
      desc: "Round-the-clock operations team available for real-time updates and issue resolution.",
      num: "04",
    },
  ];

  // ISO Certified badge removed
  const badges = [
    { icon: <FaLock />, title: "100% Insured", sub: "Every Shipment" },
    { icon: <FaMapPin />, title: "GPS Enabled", sub: "Live Fleet Tracking" },
    { icon: <FaHeadset />, title: "24/7 Support", sub: "Dedicated Team" },
    {
      icon: <FaTruckMoving />,
      title: "250+ Fleet",
      sub: "Modern Transport Vehicles",
    },
    {
      icon: <FaGlobe />,
      title: "Pan India Service",
      sub: "100+ Cities Connected",
    },
  ];

  const aboutFeatures = [
    {
      title: "40+ Years of Industry Excellence",
      desc: "Proven track record in road transport and logistics across diverse industry verticals.",
    },
    {
      title: "Pan-India Network Coverage",
      desc: "Seamless connectivity across 100+ major cities with established last-mile delivery capabilities.",
    },
    {
      title: "Technology-Driven Operations",
      desc: "GPS-enabled fleet, digital documentation, and real-time shipment tracking for full visibility.",
    },
    {
      title: "Dedicated Account Management",
      desc: "Personalized service with a committed team ensuring smooth operations at every touchpoint.",
    },
  ];

  const getInitials = (text = "") =>
    text
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();

  return (
    <div className="lp">
      {/* ══ HERO ══ */}
      <section id="home" ref={homeRef} className="hero">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
            style={{
              backgroundImage: `linear-gradient(rgba(16,22,54,.55),rgba(16,22,54,.65)),url('${slide.image}')`,
            }}
          />
        ))}
        <div className="hero-overlay" />
        <div className="hero-grid" />
        <div className="container hero-inner">
          <div className="carousel-content-wrapper">
            {heroSlides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-content ${index === currentSlide ? "active" : ""}`}
              >
                <div className="hero-eyebrow">
                  <span className="hero-dot" />
                  <span>{slide.eyebrow}</span>
                  <span className="hero-dot" />
                </div>
                <h1 className="hero-heading-carousel">
                  <span className="hero-title">{slide.title1}</span>
                  <span className="hero-title hero-title-accent">
                    {slide.title2}
                  </span>
                </h1>
                <p className="hero-desc">{slide.desc}</p>
              </div>
            ))}
          </div>
          <div className="hero-ctas">
            <button
              className="btn-primary"
              onClick={() => scrollToSection(contactRef, "contact")}
            >
              Get Instant Quote <FaArrowRight />
            </button>
            <button
              className="btn-outline"
              onClick={() => scrollToSection(servicesRef, "services")}
            >
              Explore Services
            </button>
          </div>
          <div className="hero-stats">
            {[
              { num: "500K+", label: "Shipments Delivered" },
              { num: "98.2%", label: "On-Time Rate" },
              { num: "100+", label: "Cities Covered" },
              { num: "250+", label: "Fleet Size" },
            ].map((s) => (
              <div className="hstat" key={s.label}>
                <span className="hstat-num">{s.num}</span>
                <span className="hstat-lbl">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ══ MARQUEE ══ */}
      <div className="marquee-strip">
        <div className="marquee-track">
          {[
            "🚛 Full Truck Load",
            "🏭 Warehousing Solutions",
            "🛡️ Cargo Insurance",
            "📦 Project Logistics",
            "🌐 LR Forwarding",
            "📊 Real-Time Tracking",
          ]
            .concat([
              "🚛 Full Truck Load",
              "🏭 Warehousing Solutions",
              "🛡️ Cargo Insurance",
              "📦 Project Logistics",
              "🌐 LR Forwarding",
              "📊 Real-Time Tracking",
            ])
            .map((item, i) => (
              <span key={i} className="marquee-item">
                <span className="mdot">◆</span> {item}
              </span>
            ))}
        </div>
      </div>

      {/* ══ ABOUT ══ */}
      <section id="about" ref={aboutRef} className="section about-sec">
        <div className="container">
          <div className="sec-hdr">
            <div className="tag-row">
              <span className="tag-line" />
              <span className="sec-tag">About Us</span>
              <span className="tag-line" />
            </div>
            <h2>Your Strategic Logistics Partner</h2>
          </div>

          <div className="about-top">
            {/* Left: intro content */}
            <div className="about-main-card">
              <span className="about-mini-tag">
                Reliable LR • Nationwide Reach • Transparent Operations
              </span>

              <h3>Built to Move Businesses Faster and Smarter</h3>

              <p className="about-intro">
                Paras Roadlines is a trusted road transport company delivering
                dependable freight movement across India. With a strong fleet,
                technology-enabled tracking, and responsive support, we help
                businesses move cargo safely, efficiently, and on time.
              </p>

              <div className="about-highlight-pills">
                <span>Pan-India Coverage</span>
                <span>GPS Enabled Fleet</span>
                <span>24/7 Support</span>
                <span>Secure Deliveries</span>
              </div>
            </div>

            {/* Right: badges */}
            <div className="about-badges-grid">
              {badges.map(({ icon, title, sub }) => (
                <div className="about-badge-card" key={title}>
                  <div className="badge-icon-wrap">{icon}</div>
                  <div className="badge-text-wrap">
                    <strong>{title}</strong>
                    <span>{sub}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Features */}
          <div className="about-feature-panel">
            {aboutFeatures.map(({ title, desc }) => (
              <div className="about-feature-card" key={title}>
                <div className="feat-check">
                  <FaCheckCircle />
                </div>
                <div className="about-feature-content">
                  <h4>{title}</h4>
                  <p>{desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Keep stats row unchanged */}
          <div className="stats-row">
            {stats.map(({ icon, value, label }) => (
              <div className="stat-card" key={label}>
                <div className="stat-icon">{icon}</div>
                <span className="stat-val">{value}</span>
                <p className="stat-lbl">{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ SERVICES ══ */}
      <section id="services" ref={servicesRef} className="section services-sec">
        <div className="container rel">
          <div className="sec-hdr">
            <div className="tag-row">
              <span className="tag-line" />
              <span className="sec-tag">What We Offer</span>
              <span className="tag-line" />
            </div>
            <h2>Comprehensive Logistics Solutions</h2>
            <p>
              Tailored freight services for enterprises, SMEs, and growing
              businesses across India
            </p>
          </div>
          <div className="services-grid">
            {services.map(({ icon, title, desc }) => (
              <div className="service-card" key={title}>
                <div className="srv-icon-wrap">{icon}</div>
                <h3>{title}</h3>
                <p>{desc}</p>
                <div className="srv-arrow">
                  <FaArrowRight />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ WHY US → ANYTHING, ANYWHERE ══ */}
      <section className="section why-sec">
        <div className="container rel">
          <div className="sec-hdr">
            <div className="tag-row">
              <span className="tag-line" />
              <span className="sec-tag">Anything Anywhere</span>
              <span className="tag-line" />
            </div>
            <h2>We Deliver Anything, Anywhere</h2>
            <p>
              What makes us the preferred logistics partner for 10,000+
              businesses across India
            </p>
          </div>
          <div className="why-grid">
            {whyUs.map(({ icon, title, desc, num }) => (
              <div className="why-card" key={title}>
                <div className="why-num">{num}</div>
                <div className="why-icon">{icon}</div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ OUR CUSTOMERS (auto-scrolling carousel) ══ */}
      <section ref={customersRef} className="section customers-sec">
        <div className="container rel">
          <div className="sec-hdr">
            <div className="tag-row">
              <span className="tag-line" />
              <span className="sec-tag">Our Customers</span>
              <span className="tag-line" />
            </div>
            <h2>Businesses That Trust Us</h2>
            <p>
              A growing network of partners across manufacturing, retail, and
              trade
            </p>
          </div>

          {dataLoading ? (
            <div className="carousel-loading">
              <div className="loading-spinner" />
              <span>Loading customers…</span>
            </div>
          ) : customers.length === 0 ? (
            <div className="carousel-empty">
              <span>Our customer stories are coming soon.</span>
            </div>
          ) : (
            <div className="customers-carousel-wrapper">
              <div className="customers-carousel-track">
                {/* Duplicate for seamless infinite scroll */}
                {[...customers, ...customers, ...customers, ...customers,...customers, ...customers, ...customers, ...customers].map(
                  ({ id, name, logo, initials }, i) => (
                    <div className="customer-card" key={`${id}-${i}`}>
                      <div className="customer-card-front">
                        {logo ? (
                          <img
                            src={logo}
                            alt={name}
                            className="customer-card-logo"
                            loading="lazy"
                          />
                        ) : (
                          <div className="customer-logo-fallback">
                            {initials || getInitials(name)}
                          </div>
                        )}
                      </div>
                      <div className="customer-card-overlay">
                        <span>{name}</span>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ══ TESTIMONIALS (auto-scrolling carousel) ══ */}
      <section className="section testi-sec">
        <div className="container rel">
          <div className="sec-hdr">
            <div className="tag-row">
              <span className="tag-line" />
              <span className="sec-tag">Client Stories</span>
              <span className="tag-line" />
            </div>
            <h2>Trusted by Industry Leaders</h2>
            <p>
              What our long-term partners say about working with Paras Roadlines
            </p>
          </div>

          {dataLoading ? (
            <div className="carousel-loading">
              <div className="loading-spinner" />
              <span>Loading testimonials…</span>
            </div>
          ) : testimonials.length === 0 ? (
            <div className="carousel-empty">
              <span>Client stories are coming soon.</span>
            </div>
          ) : (
            <div className="testi-carousel-wrapper">
              <div className="testi-carousel-track">
                {/* Duplicate for seamless infinite scroll */}
                {[
                  ...testimonials,
                  ...testimonials,
                  ...testimonials,
                  ...testimonials,
                ].map(({ id, text, name, role, rating, logo, initials }, i) => (
                  <div className="testimonial-card" key={`${id}-${i}`}>
                    <div className="t-stars">
                      {Array(Math.min(Math.max(Number(rating), 1), 5))
                        .fill(0)
                        .map((_, j) => (
                          <FaStar key={j} />
                        ))}
                    </div>
                    <FaQuoteLeft className="quote-icon" />
                    <p className="t-text">{text}</p>
                    <div className="t-client">
                      <div className="t-avatar">
                        {logo ? (
                          <img
                            src={logo}
                            alt={name}
                            className="t-avatar-img"
                            loading="lazy"
                          />
                        ) : (
                          <span>{initials || getInitials(name)}</span>
                        )}
                      </div>
                      <div>
                        <strong>{name}</strong>
                        <span>{role}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ══ CONTACT ══ */}
      <section id="contact" ref={contactRef} className="section contact-sec">
        <div className="container rel">
          <div className="sec-hdr">
            <div className="tag-row">
              <span className="tag-line" />
              <span className="sec-tag">Get In Touch</span>
              <span className="tag-line" />
            </div>
            <h2>Let's Move Your Cargo Forward</h2>
            <p>
              Connect with our logistics experts for a customized freight
              solution
            </p>
          </div>
          <div className="contact-grid">
            <div className="info-panel">
              <div className="info-hdr">
                <div className="info-hdr-icon">
                  <FaBuilding />
                </div>
                <div>
                  <h3>Paras Roadlines</h3>
                  <span>Transport & Logistics Since 1986</span>
                </div>
              </div>
              <div className="info-items" style={{ textAlign: "left" }}>
                {[
                  {
                    icon: <FaMapMarkerAlt />,
                    label: "Head Office",
                    val: "52, R.S. Shukla Market, Power House, Bhilai - 490 011 (Chhattisgarh)",
                  },
                  {
                    icon: <FaPhoneAlt />,
                    label: "Phone",
                    val: (
                      <a href="tel:+918966052022">
                        7999552398, 9425234581, 7974125386
                      </a>
                    ),
                  },
                  {
                    icon: <FaEnvelope />,
                    label: "Email",
                    val: (
                      <a href="mailto:paras_roadlines@rediffmail.com">
                        dispatch@parasroadlines.com
                      </a>
                    ),
                  },
                  {
                    icon: <FaClock />,
                    label: "Operations",
                    val: "24/7 — 365 days a year",
                  },
                ].map(({ icon, label, val }) => (
                  <div className="info-item" key={label}>
                    <div className="info-icon-wrap">{icon}</div>
                    <div>
                      <strong>{label}</strong>
                      <p>{val}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="social-row">
                <a href="#">
                  <FaWhatsapp />
                </a>
                <a href="#">
                  <FaLinkedin />
                </a>
                <a href="#">
                  <FaTwitter />
                </a>
              </div>
            </div>
            <div className="form-panel">
              <h3>Request a Quote</h3>
              <p>
                Fill in your details and our team will respond within 2 hours
              </p>
              <form onSubmit={handleContactSubmit} noValidate>
                <div className="form-row">
                  {/* Full Name */}
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your full name"
                      required
                      onChange={(e) => {
                        if (fieldErrors.name && e.target.value.trim()) {
                          setFieldErrors((prev) => ({ ...prev, name: "" }));
                        }
                      }}
                      onBlur={(e) => {
                        if (!e.target.value.trim()) {
                          setFieldErrors((prev) => ({
                            ...prev,
                            name: "Full name is required.",
                          }));
                        }
                      }}
                      className={fieldErrors.name ? "input-error" : ""}
                    />
                    {fieldErrors.name && (
                      <span className="field-error">{fieldErrors.name}</span>
                    )}
                  </div>

                  {/* Email */}
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      required
                      onChange={(e) => {
                        const err = validateEmail(e.target.value.trim());
                        setFieldErrors((prev) => ({ ...prev, email: err }));
                      }}
                      onBlur={(e) => {
                        const err = validateEmail(e.target.value.trim());
                        setFieldErrors((prev) => ({ ...prev, email: err }));
                      }}
                      className={fieldErrors.email ? "input-error" : ""}
                    />
                    {fieldErrors.email && (
                      <span className="field-error">{fieldErrors.email}</span>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  {/* Phone */}
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+91 XXXXX XXXXX"
                      maxLength={13}
                      onChange={(e) => {
                        // Allow only digits, spaces, +, -
                        e.target.value = e.target.value.replace(
                          /[^\d\s+\-]/g,
                          "",
                        );
                        const err = validatePhone(e.target.value.trim());
                        setFieldErrors((prev) => ({ ...prev, phone: err }));
                      }}
                      onBlur={(e) => {
                        const err = validatePhone(e.target.value.trim());
                        setFieldErrors((prev) => ({ ...prev, phone: err }));
                      }}
                      className={fieldErrors.phone ? "input-error" : ""}
                    />
                    {fieldErrors.phone ? (
                      <span className="field-error">{fieldErrors.phone}</span>
                    ) : (
                      <span className="field-hint">
                        10-digit Indian mobile number
                      </span>
                    )}
                  </div>

                  {/* Company */}
                  <div className="form-group">
                    <label>Company Name</label>
                    <input
                      type="text"
                      name="company"
                      placeholder="Your company"
                    />
                  </div>
                </div>

                {/* Message */}
                <div className="form-group">
                  <label>Message / Requirement *</label>
                  <textarea
                    name="message"
                    rows="4"
                    placeholder="Describe your freight requirement… (min 10 characters)"
                    required
                    onChange={(e) => {
                      if (
                        e.target.value.trim().length >= 10 &&
                        fieldErrors.message
                      ) {
                        setFieldErrors((prev) => ({ ...prev, message: "" }));
                      }
                    }}
                    onBlur={(e) => {
                      const val = e.target.value.trim();
                      if (!val) {
                        setFieldErrors((prev) => ({
                          ...prev,
                          message: "Message is required.",
                        }));
                      } else if (val.length < 10) {
                        setFieldErrors((prev) => ({
                          ...prev,
                          message: "Minimum 10 characters required.",
                        }));
                      } else {
                        setFieldErrors((prev) => ({ ...prev, message: "" }));
                      }
                    }}
                    className={fieldErrors.message ? "input-error" : ""}
                  />
                  {fieldErrors.message ? (
                    <span className="field-error">{fieldErrors.message}</span>
                  ) : (
                    <span className="field-hint">Minimum 10 characters</span>
                  )}
                </div>

                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <>
                      <div className="btn-spinner" />
                      <span>Sending…</span>
                    </>
                  ) : (
                    <>
                      <span>Send Enquiry</span>
                      <FaPaperPlane />
                    </>
                  )}
                </button>
              </form>

              {formFeedback && (
                <div className={`feedback ${formFeedback.type}`}>
                  {formFeedback.type === "success" ? "✅" : "⚠️"}{" "}
                  {formFeedback.message}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ══ SCROLL TOP ══ */}
      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
        >
          ↑
        </button>
      )}

      {/* ══ FLOATING WHATSAPP ══ */}
      <FloatingWhatsApp
        phoneNumber="919425234581"
        accountName="Paras Roadlines"
        avatar={logo1}
        statusMessage="Typically replies within 1 hour"
        chatMessage="Hello! 👋 Welcome to Paras Roadlines. How can we help with your logistics needs today?"
        placeholder="Type your message…"
        notification
        notificationDelay={30}
        notificationSound
        allowClickAway
      />

{/* ══ SUCCESS POPUP ══ */}
{showSuccessPopup && (
  <div className="success-popup-overlay" onClick={() => setShowSuccessPopup(false)}>
    <div className="success-popup" onClick={(e) => e.stopPropagation()}>
      <button
        className="success-popup-close"
        onClick={() => setShowSuccessPopup(false)}
      >
        <FaTimes />
      </button>

      <div className="success-popup-icon">
        <FaCheckCircle />
      </div>

      <h3>Enquiry Submitted!</h3>
      <p>
        Thank you! Your enquiry has been received successfully.
        Our team will get back to you within <strong>2 hours</strong>.
      </p>

      <div className="success-popup-progress">
        <div className="success-popup-progress-bar" />
      </div>

      <button
        className="success-popup-btn"
        onClick={() => setShowSuccessPopup(false)}
      >
        Got it, Thanks!
      </button>
    </div>
  </div>
)}
      {/* ══ STYLES ══ */}
      <style>{`
        /*
          ═══════════════════════════════════════════
          COLOR PALETTE: Light Theme — Indigo + Amber
          ═══════════════════════════════════════════
          --primary:      #4f46e5  (Indigo)
          --primary-dk:   #4338ca  (Deep Indigo)
          --primary-lt:   #eef2ff  (Indigo Tint)
          --accent:       #f59e0b  (Amber)
          --accent-lt:    #fbbf24  (Light Amber)
          --bg:           #ffffff  (Page)
          --bg-soft:      #f8f9fc  (Section alt)
          --bg-card:      #ffffff  (Card)
          --border:       #e6e8f0
          --text:         #101828
          --text-muted:   #6b7280
        */

        *,*::before,*::after{margin:0;padding:0;box-sizing:border-box;user-select:auto;}
        html{scroll-behavior:smooth;}
        body{font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;background:#ffffff;color:#101828;overflow-x:hidden;font-size:16px;}
        .lp{overflow-x:hidden;}
        .container{max-width:1200px;margin:0 auto;padding:0 clamp(16px,3vw,40px);width:100%;}
        .rel{position:relative;z-index:2;}

        /* ══ NAVBAR ══ */
        .navbar{position:fixed;top:0;width:100%;z-index:1000;transition:all .4s;}
        .nav-main{background:rgba(255,255,255,0.92);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);border-bottom:1px solid #e6e8f0;transition:all .4s;}
        .navbar.scrolled .nav-main{box-shadow:0 4px 30px rgba(16,24,40,.08);border-bottom-color:#dcdfec;}
        .nav-wrapper{display:flex;justify-content:space-between;align-items:center;height:68px;}
        .logo{display:flex;align-items:center;gap:12px;}
        .logo-icon{width:46px;height:46px;overflow:hidden;display:flex;align-items:center;justify-content:center;border:2px solid #eef2ff;background:#eef2ff;border-radius:10px;}
        .logo-img{width:100%;height:100%;object-fit:contain;}
        .logo-text h1{font-size:1.05rem;font-weight:900;letter-spacing:1px;color:#4338ca;line-height:1.2;text-transform:uppercase;}
        .logo-text span{font-size:.55rem;color:#8b8fa3;letter-spacing:2px;text-transform:uppercase;}
        .nav-links{display:flex;gap:2rem;list-style:none;align-items:center;}
        .nav-links a{text-decoration:none;color:#475069;font-weight:600;font-size:.8rem;letter-spacing:.6px;text-transform:uppercase;transition:color .3s;position:relative;padding-bottom:-4px;}
        .nav-links a::after{content:'';position:absolute;bottom:-2px;left:0;width:0;height:2px;background:#4f46e5;transition:width .3s;}
        .nav-links a:hover,.nav-links a.active{color:#4f46e5;}
        .nav-links a:hover::after,.nav-links a.active::after{width:100%;}
        .login-btn{background:#4f46e5;color:#fff;border:1.5px solid #4f46e5;padding:8px 18px;font-weight:700;font-size:.78rem;cursor:pointer;display:flex;align-items:center;gap:7px;transition:all .3s;letter-spacing:.6px;text-transform:uppercase;border-radius:8px;}
        .login-btn:hover{background:#4338ca;border-color:#4338ca;box-shadow:0 8px 20px rgba(79,70,229,.28);}
        .login-btn-mobile{display:none;}
        .menu-toggle{display:none;font-size:1.3rem;cursor:pointer;color:#4f46e5;padding:8px;}
.about-dropdown {
  position: relative;
  display: flex;
  align-items: center;
}

.about-dropdown::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 20px;
  background: transparent;
}

.about-link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  line-height: 1;
}

.about-link-text {
  display: inline-block;
  line-height: normal;
}

.about-arrow-icon {
  font-size: 18px !important;
  position: relative;
  top: 1px;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.about-dropdown:hover .about-arrow-icon {
  transform: rotate(180deg);
}

.about-dropdown-menu {
  position: absolute;
  top: calc(100% + 2px);   /* moved slightly up */
  left: -12px;             /* moved slightly left */
  min-width: 190px;        /* optional: a bit wider */
  background: #fff;
  border-radius: 0px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.08);
  z-index: 1000;

  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  pointer-events: none;

  transition:
    opacity 0.3s ease,
    transform 0.3s ease,
    visibility 0.3s ease;
}

.about-dropdown:hover .about-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}

.about-dropdown-item {
  display: block;
  padding: 14px 20px;   /* increased padding all sides */
  text-decoration: none;
  color: #475069;
  font-size: .8rem;
  font-weight: 600;
  letter-spacing: .6px;
  text-transform: uppercase;
  white-space: nowrap;
  transition: background 0.2s ease, color 0.2s ease;
}
.about-dropdown-item:hover {
  background: #eef2ff;
  color: #4f46e5;
}

@media (max-width: 768px) {
  .about-dropdown {
    flex-direction: column;
    align-items: center;
  }

  .about-dropdown::after {
    display: none;
  }

  .about-dropdown-menu {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: none;
    pointer-events: auto;
    min-width: 100%;
    background: transparent;
    border: none;
    box-shadow: none;
    border-radius: 0;
    margin-top: 6px;
    transition: none;
  }

  .about-dropdown-item {
    padding: 6px 0 6px 12px;
    font-size: 13px;
    text-align: center;
  }
}
  
         /* ══ Hero Section ══ */
      .hero{min-height:100vh;position:relative;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#101636;padding-top:68px;}
        .hero-overlay{position:absolute;inset:0;z-index:1;background:radial-gradient(ellipse at 20% 50%,rgba(79,70,229,.25) 0%,transparent 55%),radial-gradient(ellipse at 80% 50%,rgba(245,158,11,.12) 0%,transparent 55%);}
        .hero-grid{position:absolute;inset:0;z-index:1;background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);background-size:60px 60px;}
       .hero-inner{position:relative;z-index:2;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;padding:clamp(120px,16vh,160px) clamp(16px,3vw,40px) clamp(40px,6vh,60px);}
        .hero-eyebrow{display:inline-flex;align-items:center;gap:14px;margin-bottom:3.2rem;color:#fbbf24;font-size:.65rem;letter-spacing:3px;text-transform:uppercase;font-weight:700;}
        .hero-dot{width:6px;height:6px;background:#fbbf24;display:inline-block;transform:rotate(45deg);}
        .hero-heading-carousel{display:inline-block;user-select:none;margin-bottom:1rem;}
        .hero-title{display:block;font-size: clamp(2.2rem, 7vw, 5rem);
        font-weight:900;line-height:.95;letter-spacing:clamp(-1px,-0.3vw,-2px);text-transform:uppercase;color:#fff;}
        .hero-title-accent{color:#fbbf24 !important;}
        .hero-desc{font-size:clamp(.82rem,1.1vw,.95rem);color:rgb(255, 255, 255);max-width:500px;margin:0 auto;line-height:1.8;}
        .hero-ctas{display:flex;gap:.75rem;justify-content:center;margin-top:3.5rem;margin-bottom:clamp(2rem,4vh,3rem);flex-wrap:wrap;}
        .btn-primary{background:linear-gradient(135deg,#f59e0b,#d97706);color:#101636;border:none;padding:12px 28px;font-weight:800;font-size:.82rem;cursor:pointer;display:inline-flex;align-items:center;gap:10px;letter-spacing:1px;text-transform:uppercase;transition:all .3s;border-radius:8px;}
        .btn-primary:hover{background:linear-gradient(135deg,#fbbf24,#f59e0b);transform:translateY(-2px);box-shadow:0 12px 35px rgba(245,158,11,.35);}
        .btn-outline{background:rgba(255,255,255,.06);color:#fff;border:1.5px solid rgba(255,255,255,.35);padding:12px 28px;font-weight:700;font-size:.82rem;cursor:pointer;letter-spacing:1px;text-transform:uppercase;transition:all .3s;border-radius:8px;}
        .btn-outline:hover{background:rgba(255,255,255,.14);border-color:rgba(255,255,255,.6);transform:translateY(-2px);}
        .hero-stats{display:flex;justify-content:center;border-top:1px solid rgba(255,255,255,.14);padding-top:clamp(1rem,3vh,2rem);gap:0;flex-wrap:wrap;width:100%;margin-top:auto;}
        .hstat{text-align:center;padding:0 clamp(1rem,3vw,2.5rem);border-right:1px solid rgba(255,255,255,.12);}
        .hstat:last-child{border-right:none;}
        .hstat-num{display:block;font-size:clamp(1.2rem,2.5vw,1.8rem);font-weight:900;color:#fbbf24;letter-spacing:-1px;}
        .hstat-lbl{display:block;font-size:.6rem;color:rgba(255,255,255,.55);text-transform:uppercase;letter-spacing:1.5px;margin-top:3px;}

        /* ══ CAROUSEL ══ */
        .carousel-slide{position:absolute;inset:0;background-size:cover;background-position:center;background-repeat:no-repeat;opacity:0;transition:opacity 1.2s ease-in-out;will-change:opacity;transform:scale(1.05);}
        .carousel-slide.active{opacity:1;animation:carouselZoom 5s ease-in-out forwards;}
        @keyframes carouselZoom{0%{transform:scale(1.05);}100%{transform:scale(1.12);}}

        .carousel-content-wrapper{position:relative;width:100%;min-height:300px;display:flex;align-items:center;justify-content:center;}
        .carousel-content{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center;opacity:0;transform:translateY(25px);transition:all .8s cubic-bezier(.4,0,.2,1);pointer-events:none;text-align:center;}
        .carousel-content.active{opacity:1;transform:translateY(0);pointer-events:auto;}

        @media(max-width:768px){
          .carousel-content-wrapper{min-height:260px;}
          .hstat{padding:0 1.25rem;}
        }
        @media(max-width:480px){
          .hero-title{font-size:clamp(2rem,10vw,3rem);letter-spacing:-1px;}
          .carousel-content-wrapper{min-height:230px;}
          .hstat{padding:0 .75rem;border-right:none;width:50%;border-bottom:1px solid rgba(255,255,255,.1);}
          .hero-ctas{flex-direction:column;align-items:stretch;}
          .btn-primary,.btn-outline{justify-content:center;}
        }

        /* ══ LOADING & EMPTY STATES ══ */
.carousel-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem 0;
  color: #8b8fa3;
  font-size: 0.82rem;
}

.loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e6e8f0;
  border-top-color: #4f46e5;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.carousel-empty {
  text-align: center;
  padding: 3rem 0;
  color: #8b8fa3;
  font-size: 0.82rem;
  border: 1px dashed #e6e8f0;
  border-radius: 12px;
}

                /* ══ MARQUEE ══ */
                .marquee-strip{background:linear-gradient(135deg,#4f46e5,#4338ca);overflow:hidden;padding:13px 0;}
                .marquee-track{display:flex;animation:mq 35s linear infinite;width:max-content;}
                .marquee-item{color:rgba(255,255,255,.85);font-size:.68rem;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:0 2rem;display:flex;align-items:center;gap:8px;white-space:nowrap;transition:color .3s;}
                .marquee-item:hover{color:#fbbf24;}
                .mdot{color:#fbbf24;font-size:.45rem;}
                @keyframes mq{0%{transform:translateX(0);}100%{transform:translateX(-50%);}}

        /* ══ SECTION COMMONS ══ */
        .section{padding:clamp(50px,8vh,90px) 0;position:relative;}
        .sec-hdr{text-align:center;margin-bottom:clamp(2rem,4vh,3.5rem);}
        .tag-row{display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:1rem;}
        .tag-line{width:40px;height:1px;background:#c7cbe8;}
        .sec-tag{font-size:.62rem;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#4f46e5;}
        .sec-hdr h2{font-size:clamp(1.5rem,3vw,2.4rem);font-weight:900;color:#101828;margin-bottom:.75rem;letter-spacing:-1px;line-height:1.15;}
        .sec-hdr p{color:#6b7280;font-size:.88rem;max-width:520px;margin:0 auto;line-height:1.7;}

        /* ══ ABOUT ══ */
.about-sec{
  background:#ffffff;
  overflow:hidden;
}

.about-top{
  display:grid;
  grid-template-columns:1.15fr .85fr;
  gap:clamp(1.25rem,3vw,2rem);
  align-items:stretch;
  margin-bottom:clamp(1.5rem,3vh,2.25rem);
}

.about-main-card{
  background:linear-gradient(135deg,#ffffff 0%,#f8f9fc 100%);
  border:1px solid #e6e8f0;
  border-radius:18px;
  padding:clamp(1.5rem,3vw,2.25rem);
  box-shadow:0 12px 28px rgba(16,24,40,.04);
}

.about-mini-tag{
  display:inline-block;
  font-size:.62rem;
  font-weight:800;
  letter-spacing:2px;
  text-transform:uppercase;
  color:#4f46e5;
  background:#eef2ff;
  padding:8px 12px;
  border-radius:999px;
  margin-bottom:1rem;
}

.about-main-card h3{
  font-size:clamp(1.25rem,2.2vw,1.8rem);
  font-weight:900;
  color:#101828;
  line-height:1.2;
  letter-spacing:-.5px;
  margin-bottom:.9rem;
  text-align:left;
}

.about-intro{
  color:#4b5266;
  font-size:.9rem;
  line-height:1.9;
  text-align:left;
  margin-bottom:1.25rem;
}

.about-highlight-pills{
  display:flex;
  flex-wrap:wrap;
  gap:.7rem;
}

.about-highlight-pills span{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding:8px 12px;
  border-radius:999px;
  background:#ffffff;
  border:1px solid #e6e8f0;
  color:#475069;
  font-size:.72rem;
  font-weight:700;
  box-shadow:0 4px 12px rgba(16,24,40,.03);
}

.about-badges-grid{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  gap:1rem;
}

.about-badge-card{
  background:#ffffff;
  border:1px solid #e6e8f0;
  border-radius:16px;
  padding:1.1rem 1rem;
  display:flex;
  align-items:center;
  gap:12px;
  transition:all .3s;
  position:relative;
  overflow:hidden;
  min-height:92px;
}

.about-badge-card::before{
  content:'';
  position:absolute;
  bottom:0;
  left:0;
  width:0;
  height:3px;
  background:linear-gradient(90deg,#4f46e5,#4338ca);
  transition:width .35s;
}

.about-badge-card:hover::before{
  width:100%;
}

.about-badge-card:hover{
  transform:translateY(-3px);
  box-shadow:0 10px 24px rgba(16,24,40,.06);
  border-color:#d7dafc;
  background:#f8f9fc;
}

.badge-icon-wrap{
  width:42px;
  height:42px;
  background:#eef2ff;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
  border-radius:10px;
}

.badge-icon-wrap svg{
  font-size:1.15rem;
  color:#4f46e5;
}

.badge-text-wrap{
  text-align:left;
}

.badge-text-wrap strong{
  display:block;
  font-size:.82rem;
  font-weight:700;
  color:#101828;
  margin-bottom:2px;
}

.badge-text-wrap span{
  font-size:.68rem;
  color:#8b8fa3;
  line-height:1.5;
}

/* center the last card when badges count is odd */
.about-badges-grid .about-badge-card:last-child{
  grid-column:1 / -1;
  max-width:calc(50% - .5rem);
  width:100%;
  justify-self:center;
}

.about-feature-panel{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  gap:1rem;
  margin-bottom:clamp(2rem,4vh,4rem);
}

.about-feature-card{
  background:#ffffff;
  border:1px solid #e6e8f0;
  border-radius:14px;
  padding:1rem;
  display:flex;
  align-items:flex-start;
  gap:.9rem;
  transition:all .3s;
}

.about-feature-card:hover{
  background:#f8f9fc;
  border-color:#d7dafc;
  box-shadow:0 10px 24px rgba(16,24,40,.04);
}

.feat-check{
  width:34px;
  height:34px;
  background:#eef2ff;
  border-left:3px solid #4f46e5;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
  border-radius:8px;
}

.feat-check svg{
  color:#4f46e5;
  font-size:.9rem;
}

.about-feature-content{
  text-align:left;
}

.about-feature-content h4{
  font-size:.85rem;
  font-weight:700;
  color:#101828;
  margin-bottom:4px;
}

.about-feature-content p{
  font-size:.78rem;
  color:#6b7280;
  line-height:1.65;
}

.stats-row{display:grid;grid-template-columns:repeat(6,1fr);gap:1px;background:#e6e8f0;border:1px solid #e6e8f0;border-radius:12px;overflow:hidden;}
.stat-card{background:#ffffff;padding:1.5rem .75rem;text-align:center;transition:all .3s;position:relative;overflow:hidden;}
.stat-card::after{content:'';position:absolute;bottom:0;left:0;width:0;height:3px;background:linear-gradient(90deg,#4f46e5,#4338ca);transition:width .4s;}
.stat-card:hover::after{width:100%;}
.stat-card:hover{background:#f8f9fc;}
.stat-icon{width:40px;height:40px;background:#eef2ff;border-radius:8px;display:flex;align-items:center;justify-content:center;margin:0 auto .7rem;}
.stat-icon svg{font-size:1.1rem;color:#4f46e5;}
.stat-val{display:block;font-size:clamp(1.1rem,2vw,1.4rem);font-weight:900;color:#101828;letter-spacing:-.5px;}
.stat-lbl{font-size:.58rem;color:#8b8fa3;text-transform:uppercase;letter-spacing:1.2px;margin-top:4px;display:block;}

        /* ══ SERVICES ══ */
        .services-sec{background:#f8f9fc;overflow:hidden;}
        .services-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:1px;background:#e6e8f0;border:1px solid #e6e8f0;border-radius:12px;overflow:hidden;}
        .service-card{background:#ffffff;padding:clamp(1.25rem,2.5vw,2rem) clamp(1rem,2vw,1.5rem);transition:all .35s;position:relative;overflow:hidden;cursor:pointer;}
        .service-card::before{content:'';position:absolute;top:0;left:0;width:3px;height:0;background:linear-gradient(to bottom,#4f46e5,#4338ca);transition:height .4s;}
        .service-card:hover::before{height:100%;}
        .service-card:hover{background:#f8f9fc;transform:translateY(-3px);}
        .srv-icon-wrap{width:46px;height:46px;background:#eef2ff;display:flex;align-items:center;justify-content:center;margin-bottom:1.25rem;transition:all .3s;border-radius:10px;}
        .service-card:hover .srv-icon-wrap{background:linear-gradient(135deg,#4f46e5,#4338ca);}
        .srv-icon-wrap svg{font-size:1.2rem;color:#4f46e5;transition:color .3s;}
        .service-card:hover .srv-icon-wrap svg{color:#fff;}
        .service-card h3{color:#101828;font-size:.88rem;font-weight:700;margin-bottom:.6rem;line-height:1.3;}
        .service-card p{color:#6b7280;font-size:.78rem;line-height:1.7;}
        .srv-arrow{margin-top:1.25rem;color:#c7cbe8;display:inline-flex;transition:all .3s;}
        .service-card:hover .srv-arrow{color:#4f46e5;transform:translateX(5px);}

        /* ══ ANYTHING ANYWHERE (formerly Why Us) ══ */
        .why-sec{background:#ffffff;overflow:hidden;}
        .why-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:#e6e8f0;border:1px solid #e6e8f0;border-radius:12px;overflow:hidden;}
        .why-card{background:#ffffff;padding:clamp(1.5rem,3vw,2.5rem) clamp(1rem,2vw,1.75rem);text-align:center;transition:all .35s;position:relative;overflow:hidden;}
        .why-card::after{content:'';position:absolute;bottom:0;left:0;width:0;height:3px;background:linear-gradient(90deg,#4f46e5,#4338ca);transition:width .4s;}
        .why-card:hover::after{width:100%;}
        .why-card:hover{background:#f8f9fc;transform:translateY(-3px);}
        .why-num{position:absolute;top:1rem;right:1.25rem;font-size:3rem;font-weight:900;color:#f1f2f9;line-height:1;transition:color .3s;}
        .why-card:hover .why-num{color:#e4e6f5;}
        .why-icon{width:56px;height:56px;background:#eef2ff;display:flex;align-items:center;justify-content:center;margin:0 auto 1.25rem;transition:all .3s;border-radius:12px;}
        .why-card:hover .why-icon{background:linear-gradient(135deg,#4f46e5,#4338ca);box-shadow:0 10px 25px rgba(79,70,229,.25);}
        .why-icon svg{font-size:1.3rem;color:#4f46e5;transition:color .3s;}
        .why-card:hover .why-icon svg{color:#fff;}
        .why-card h3{font-size:.9rem;font-weight:700;color:#101828;margin-bottom:.6rem;}
        .why-card p{font-size:.78rem;color:#6b7280;line-height:1.7;}

       /* ══ CUSTOMERS CAROUSEL ══ */
.customers-sec {
  background: #f8f9fc;
  overflow: hidden;
}

.customers-carousel-wrapper {
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: 4px;
  mask-image: linear-gradient(
    to right,
    transparent,
    black 8%,
    black 92%,
    transparent
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    black 8%,
    black 92%,
    transparent
  );
}

.customers-carousel-track {
  display: flex;
  gap: 1.25rem;
  width: max-content;
  animation: customerScroll 8s linear infinite;
}

/* Stops full carousel when hovered */
.customers-carousel-track:hover {
  animation-play-state: paused;
}

.customer-card {
  position: relative;
  min-width: 240px;
  height: 140px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e6e8f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.customer-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.08);
  border-color: #d7dafc;
}

.customer-card-front {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  transition: transform 0.35s ease;
}

.customer-card:hover .customer-card-front {
  transform: scale(1.05);
}

.customer-card-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 16px;
  display: block;
  background: #ffffff;
}

.customer-logo-fallback {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #4f46e5, #4338ca);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 1px;
}

/* Customer card overlay — slide up reveal */
.customer-card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(16, 24, 40, 0.42);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  /* Start hidden below */
  opacity: 0;
  transform: translateY(100%);
  transition:
    transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    opacity 0.35s ease;
}

.customer-card:hover .customer-card-overlay {
  opacity: 1;
  transform: translateY(0);
}

/* Text slides up with slight delay */
.customer-card-overlay span {
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1.4;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.7px;

  /* Text starts slightly below, eases in */
  opacity: 0;
  transform: translateY(12px);
  transition:
    transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s,
    opacity 0.2s ease 0.12s;
}

.customer-card:hover .customer-card-overlay span {
  opacity: 0.3;
  transform: translateY(0);
  color: #ffffff;
}

@keyframes customerScroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 768px) {
  .customer-card {
    min-width: 190px;
    height: 120px;
  }

  .customers-carousel-track {
    gap: 1rem;
  }

  .customer-card-logo {
    padding: 14px;
  }

  .customer-logo-fallback {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .customer-card {
    min-width: 165px;
    height: 105px;
  }

  .customers-carousel-track {
    gap: 0.75rem;
    animation-duration: 20s;
  }

  .customer-card-logo {
    padding: 12px;
  }

  .customer-logo-fallback {
    font-size: 1.25rem;
  }

  .customer-card-overlay span {
    font-size: 0.72rem;
  }
}


       /* ══ TESTIMONIALS CAROUSEL ══ */
.testi-sec {
  background: #ffffff;
  overflow: hidden;
}

.testi-carousel-wrapper {
  overflow: hidden;
  position: relative;
  width: 100%;
  mask-image: linear-gradient(
    to right,
    transparent,
    black 6%,
    black 94%,
    transparent
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    black 6%,
    black 94%,
    transparent
  );
}

.testi-carousel-track {
  display: flex;
  gap: 1rem;
  width: max-content;
  animation: testiScroll 15s linear infinite;
}

.testi-carousel-track:hover {
  animation-play-state: paused;
}

.testimonial-card {
  background: #ffffff;
  border: 1px solid #e6e8f0;
  border-radius: 12px;
  padding: 1.25rem;
  transition: all 0.35s;
  position: relative;
  overflow: hidden;
  min-width: 280px;
  max-width: 280px;
  height: 240px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.testimonial-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 0;
  background: linear-gradient(to bottom, #f59e0b, transparent);
  transition: height 0.5s;
}

.testimonial-card:hover::before {
  height: 100%;
}

.testimonial-card:hover {
  background: #f8f9fc;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06);
  border-color: #d7dafc;
}

.t-stars {
  display: flex;
  gap: 2px;
  margin-bottom: 0.5rem;
}

.t-stars svg {
  color: #f59e0b;
  font-size: 0.65rem;
}

.quote-icon {
  color: #e0e3f5;
  font-size: 1.1rem;
  margin-bottom: 0.4rem;
  display: block;
  flex-shrink: 0;
}

.t-text {
  color: #374151;
  font-size: 0.72rem;
  line-height: 1.7;
  font-style: italic;
  margin-bottom: auto;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.t-client {
  display: flex;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #eceef5;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
  flex-shrink: 0;
}

/* Updated testimonial logo/avatar */
.t-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #4f46e5, #4338ca);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 800;
  color: #ffffff;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.t-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #ffffff;
}

.t-avatar span {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.t-client strong {
  display: block;
  color: #101828;
  font-size: 0.72rem;
  font-weight: 700;
}

.t-client span {
  font-size: 0.6rem;
  color: #8b8fa3;
}

@keyframes testiScroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 768px) {
  .testimonial-card {
    min-width: 240px;
    max-width: 240px;
    height: 220px;
    padding: 1rem;
  }

  .testi-carousel-track {
    gap: 0.75rem;
    animation-duration: 25s;
  }
}

@media (max-width: 480px) {
  .testimonial-card {
    min-width: 220px;
    max-width: 220px;
    height: 210px;
    padding: 0.875rem;
  }

  .testi-carousel-track {
    gap: 0.5rem;
    animation-duration: 20s;
  }

  .t-avatar {
    width: 30px;
    height: 30px;
    font-size: 0.68rem;
  }
}
        /* ══ CONTACT ══ */
        .contact-sec{background:#f8f9fc;overflow:hidden;}
        .contact-grid{display:grid;grid-template-columns:1fr 1.6fr;gap:1px;background:#e6e8f0;align-items:stretch;border:1px solid #e6e8f0;border-radius:12px;overflow:hidden;}
        .info-panel{background:#101636;padding:clamp(1.5rem,3vw,2.5rem);color:#fff;}
        .info-hdr{display:flex;align-items:center;gap:.875rem;margin-bottom:2rem;padding-bottom:1.5rem;border-bottom:1px solid rgba(255,255,255,.1);}
        .info-hdr-icon{width:48px;height:48px;background:rgba(255,255,255,.08);border-left:3px solid #fbbf24;display:flex;align-items:center;justify-content:center;flex-shrink:0;border-radius:8px;}
        .info-hdr-icon svg{font-size:1.3rem;color:#fbbf24;}
        .info-hdr h3{font-size:1.1rem;font-weight:800;color:#fff;letter-spacing:.5px;}
        .info-hdr span{font-size:.68rem;color:#fbbf24;display:block;margin-top:3px;}
        .info-items{display:flex;flex-direction:column;gap:1rem;margin-bottom:2rem;}
        .info-item{display:flex;gap:.875rem;align-items:flex-start;}
        .info-icon-wrap{width:34px;height:34px;background:rgba(255,255,255,.06);border-left:2px solid rgba(251,191,36,.5);display:flex;align-items:center;justify-content:center;flex-shrink:0;border-radius:6px;}
        .info-icon-wrap svg{font-size:.85rem;color:#fbbf24;}
        .info-item strong{display:block;font-size:.6rem;font-weight:700;color:#fbbf24;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:3px;}
        .info-item p{font-size:.82rem;color:rgba(255,255,255,.85);font-weight:500;}
        .info-item p a{color:rgba(255,255,255,.85);text-decoration:none;transition:color .2s;}
        .info-item p a:hover{color:#fbbf24;}
        .social-row{display:flex;gap:.65rem;}
        .social-row a{width:36px;height:36px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;color:#fbbf24;font-size:.9rem;transition:all .3s;text-decoration:none;border-radius:8px;}
        .social-row a:hover{background:#fbbf24;color:#101636;border-color:#fbbf24;transform:translateY(-2px);}
        .form-panel{background:#ffffff;padding:clamp(1.5rem,3vw,2.5rem);}
        .form-panel h3{font-size:1.3rem;font-weight:900;color:#101828;margin-bottom:.4rem;letter-spacing:-.5px;}
        .form-panel>p{color:#6b7280;font-size:.8rem;margin-bottom:1.5rem;}
        .form-row{display:grid;grid-template-columns:1fr 1fr;gap:.875rem;}
        .form-group{margin-bottom:1rem;}
        .form-group label{display:block;font-size:.6rem;font-weight:700;color:#4f46e5;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:6px;text-align: left;}
        .form-panel input,.form-panel textarea{width:100%;padding:10px 14px;border:1px solid #dde0ec;border-radius:8px;font-size:.82rem;color:#101828;transition:all .3s;outline:none;background:#f8f9fc;font-family:inherit;}
        .form-panel input::placeholder,.form-panel textarea::placeholder{color:#a0a4b8;}
        .form-panel input:focus,.form-panel textarea:focus{border-color:#4f46e5;background:#fff;box-shadow:0 0 0 3px rgba(79,70,229,.12);}
        .form-panel textarea{resize:vertical;min-height:100px;}
        .form-panel button[type="submit"]{width:100%;background:linear-gradient(135deg,#4f46e5,#4338ca);color:#fff;border:none;padding:13px;font-size:.82rem;font-weight:800;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;transition:all .3s;letter-spacing:1.5px;text-transform:uppercase;border-radius:8px;}
        .form-panel button[type="submit"]:hover:not(:disabled){background:linear-gradient(135deg,#4338ca,#3730a3);box-shadow:0 12px 30px rgba(79,70,229,.3);transform:translateY(-2px);}
        .form-panel button[type="submit"]:disabled{opacity:.6;cursor:not-allowed;}
        .feedback{margin-top:.875rem;padding:12px 16px;font-size:.8rem;font-weight:500;text-align:center;border-left:3px solid;border-radius:6px;}
        .feedback.success{background:#eef2ff;color:#4338ca;border-color:#4f46e5;}
        .feedback.error{background:#fef2f2;color:#dc2626;border-color:#ef4444;}

        /* ══ SCROLL TOP ══ */
        .scroll-top-btn{position:fixed;bottom:100px;right:24px;z-index:9998;width:44px;height:44px;background:linear-gradient(135deg,#4f46e5,#4338ca);color:#fff;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:1.1rem;font-weight:900;border-radius:50%;box-shadow:0 8px 22px rgba(79,70,229,.35);transition:all .3s;animation:fadeUp .3s ease;}
        .scroll-top-btn:hover{background:linear-gradient(135deg,#4338ca,#3730a3);transform:translateY(-3px);box-shadow:0 12px 28px rgba(79,70,229,.45);}
        @keyframes fadeUp{from{opacity:0;transform:translateY(10px);}to{opacity:1;transform:translateY(0);}}

        /* ══ FOOTER ══ */
        footer{background:#101636;}
        .footer-top{padding:3.5rem 0 3rem;border-bottom:1px solid rgba(255,255,255,.06);position:relative;}
        .footer-grid{display:grid;grid-template-columns:2fr 1fr 1fr 1.2fr;gap:clamp(1.5rem,3vw,3.5rem);}
        .footer-logo{display:flex;align-items:center;gap:12px;margin-bottom:1.25rem;}
        .footer-logo img{width:42px;height:42px;object-fit:contain;border-radius:8px;border:1px solid rgba(255,255,255,.15);}
        .footer-logo h3{font-size:.95rem;font-weight:900;color:#fbbf24;letter-spacing:1px;text-transform:uppercase;}
        .footer-logo span{font-size:.58rem;color:rgba(255,255,255,.4);letter-spacing:2px;display:block;margin-top:2px;}
        .footer-brand p{color:rgba(255,255,255,.5);font-size:.8rem;line-height:1.75;margin-bottom:1.25rem;}
        .footer-social{display:flex;gap:.5rem;}
        .footer-social a{width:34px;height:34px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);display:flex;align-items:center;justify-content:center;color:#fbbf24;transition:all .3s;text-decoration:none;font-size:.85rem;border-radius:8px;}
        .footer-social a:hover{background:#fbbf24;color:#101636;border-color:#fbbf24;}
        .footer-col h4{color:#fbbf24;font-size:.6rem;font-weight:700;letter-spacing:3px;text-transform:uppercase;margin-bottom:1.25rem;padding-bottom:.65rem;border-bottom:1px solid rgba(255,255,255,.1);}
        .footer-col a{display:block;color:rgba(255,255,255,.55);text-decoration:none;font-size:.8rem;margin-bottom:.6rem;transition:all .2s;padding-left:0;}
        .footer-col a:hover{color:#fbbf24;padding-left:5px;}
        .footer-addr{color:rgba(255,255,255,.35);margin-top:.5rem;font-size:.82rem;line-height:1.7;}
        .footer-bottom{padding:1.25rem 0;border-top:1px solid rgba(255,255,255,.06);}
        .footer-bottom .container{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:.5rem;}
        .footer-bottom p{color:rgba(255,255,255,.4);font-size:.72rem;letter-spacing:.5px;}
        .footer-bottom a{color:rgba(255,255,255,.55);}
        .footer-bottom a:hover{color:#fbbf24;}

        /* ══ SUCCESS POPUP ══ */
.success-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 40, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  animation: overlayIn 0.3s ease;
}

@keyframes overlayIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.success-popup {
  background: #ffffff;
  border-radius: 20px;
  padding: clamp(2rem, 5vw, 3rem) clamp(1.5rem, 4vw, 2.5rem);
  max-width: 440px;
  width: 100%;
  text-align: center;
  position: relative;
  box-shadow: 0 32px 80px rgba(16, 24, 40, 0.22);
  animation: popupIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 1px solid #e6e8f0;
}

@keyframes popupIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.success-popup-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 32px;
  height: 32px;
  background: #f8f9fc;
  border: 1px solid #e6e8f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8b8fa3;
  font-size: 0.75rem;
  transition: all 0.2s;
}

.success-popup-close:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.success-popup-icon {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  animation: iconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both;
}

@keyframes iconPop {
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.success-popup-icon svg {
  font-size: 2rem;
  color: #4f46e5;
}

.success-popup h3 {
  font-size: 1.4rem;
  font-weight: 900;
  color: #101828;
  letter-spacing: -0.5px;
  margin-bottom: 0.75rem;
}

.success-popup p {
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.75;
  margin-bottom: 1.5rem;
}

.success-popup p strong {
  color: #4f46e5;
  font-weight: 700;
}

.success-popup-details {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.success-popup-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #16a34a;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}

.success-popup-tag svg {
  font-size: 0.9rem;
}

.success-popup-progress {
  height: 3px;
  background: #f1f2f9;
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.success-popup-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #4f46e5, #4338ca);
  border-radius: 999px;
  animation: progressShrink 5s linear forwards;
}

@keyframes progressShrink {
  from { width: 100%; }
  to   { width: 0%; }
}

.success-popup-btn {
  width: 100%;
  background: linear-gradient(135deg, #4f46e5, #4338ca);
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}

.success-popup-btn:hover {
  background: linear-gradient(135deg, #4338ca, #3730a3);
  box-shadow: 0 10px 28px rgba(79, 70, 229, 0.3);
  transform: translateY(-2px);
}

@media (max-width: 480px) {
  .success-popup {
    padding: 1.75rem 1.25rem;
    border-radius: 16px;
  }

  .success-popup-icon {
    width: 60px;
    height: 60px;
  }

  .success-popup-icon svg {
    font-size: 1.6rem;
  }

  .success-popup h3 {
    font-size: 1.2rem;
  }
}

/* ══ FORM VALIDATION ══ */
.input-error {
  border-color: #ef4444 !important;
  background: #fff5f5 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

.input-error:focus {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15) !important;
}

.field-error {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  font-size: 0.68rem;
  font-weight: 600;
  color: #dc2626;
  animation: errorIn 0.2s ease;
}

.field-error::before {
  content: "⚠";
  font-size: 0.65rem;
}

.field-hint {
  display: block;
  margin-top: 5px;
  font-size: 0.65rem;
  color: #a0a4b8;
}

@keyframes errorIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Submit button spinner */
.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}

        /* ══ RESPONSIVE ══ */
        @media(max-width:1100px){
          .services-grid{grid-template-columns:repeat(3,1fr);}
          .stats-row{grid-template-columns:repeat(3,1fr);}
          .why-grid{grid-template-columns:repeat(2,1fr);}
          .footer-grid{grid-template-columns:1fr 1fr;gap:2rem;}
        }
        @media(max-width:900px){
          .about-top{grid-template-columns:1fr;gap:1.25rem;}
          .about-feature-panel{grid-template-columns:1fr;}
          .contact-grid{grid-template-columns:1fr;}
        }
        @media(max-width:768px){
          .menu-toggle{display:flex;}
          .nav-links{display:none;position:absolute;top:68px;left:0;right:0;background:#ffffff;flex-direction:column;padding:1.25rem;gap:1rem;text-align:center;border-top:1px solid #e6e8f0;border-bottom:1px solid #e6e8f0;}
          .nav-links.open{display:flex;}
          .login-btn{display:none;}
          .login-btn-mobile{display:inline-flex;align-items:center;justify-content:center;gap:8px;background:linear-gradient(135deg,#4f46e5,#4338ca);color:#fff;border:none;padding:10px 22px;width:100%;font-weight:800;font-size:.82rem;cursor:pointer;letter-spacing:1px;text-transform:uppercase;border-radius:8px;}
          .hstat{padding:0 1.25rem;}
          .services-grid{grid-template-columns:1fr 1fr;}
          .stats-row{grid-template-columns:repeat(2,1fr);}
          .why-grid{grid-template-columns:1fr;}
          .about-badges{grid-template-columns:1fr 1fr;}
          .footer-grid{grid-template-columns:1fr;gap:1.75rem;}
          .footer-bottom .container{justify-content:center;text-align:center;}
          .form-row{grid-template-columns:1fr;}
          .container{padding:0 16px;}
          .about-badges-grid{
          .grid-template-columns:1fr 1fr;
            }
          .about-badges-grid .about-badge-card:last-child{
              grid-column:1 / -1;
              max-width:calc(50% - .5rem);
            }
          }
        @media(max-width:480px){
          .hero-title{font-size:clamp(2.5rem,12vw,3.5rem);letter-spacing:-1.5px;}
          .hstat{padding:0 .75rem;border-right:none;width:50%;border-bottom:1px solid rgba(255,255,255,.1);}
          .hero-ctas{flex-direction:column;align-items:stretch;}
          .btn-primary,.btn-outline{justify-content:center;}
          .about-badges{grid-template-columns:1fr;}
          .services-grid{grid-template-columns:1fr;}
          .footer-grid{grid-template-columns:1fr;}
          .stats-row{grid-template-columns:repeat(2,1fr);}
          .about-badges-grid{
          .grid-template-columns:1fr;
          }

          .about-badges-grid .about-badge-card:last-child{
            grid-column:auto;
            max-width:100%;
          }
        }
      `}</style>
    </div>
  );
}

export default LandingPage01;
